module.exports = __webpack_public_path__ + "aad9971520762a88f733860fa13f564b.svg";


//////////////////
// WEBPACK FOOTER
// ./images/new-form-red.svg
// module id = 103
// module chunks = 0